import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { useHistory } from "react-router-dom";
import Button from '@mui/material/Button';
import ButtonCustomStyle from "./ButtonCustomStyle";
import SocialLinks from "./SocialLinks";

function LogoMark() {
  return (
    <div className="h-6 w-6 rounded-full bg-gradient-to-br from-emerald-400 to-cyan-400 flex items-center justify-center text-slate-950 font-black text-xs shadow">CMD</div>
  );
}


export default function BottomPart(props) {

  const history = useHistory();

  const changeHistory = (_from, _to) => {
    history.push(_to, { from: _from })
  };

    return (
        <footer className="relative z-10 border-t border-white/5 bg-slate-950/95">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
            {/* Social links (added) */}
            <div className="w-full flex justify-center mb-4">
              <SocialLinks />
            </div>
    
            <div className={`grid gap-8 text-sm ${props.user_loged_in ? 'md:grid-cols-3' : 'md:grid-cols-4'}`}>
                {/* Left column – brand (always) */}
                <div className="md:text-left">
                    <div className="flex items-center gap-2 font-semibold">
                    <LogoMark /> CryptoMarketDarts
                    </div>
                    <p className="mt-2 text-slate-400">
                    Time-sensitive research and analytics for top crypto assets.
                    </p>
                </div>

                {/* Product column – only when NOT logged in */}
                {!props.user_loged_in && (
                    <div className="md:text-left">
                    <h4 className="font-semibold mb-2">Product</h4>
                    <ul className="space-y-1 text-slate-300">
                        <li><a href="#news" className="hover:text-white">News Flash</a></li>
                        <li><a href="#performance" className="hover:text-white">Dashboard</a></li>
                        <li><a href="#features" className="hover:text-white">Features</a></li>
                    </ul>
                    </div>
                )}

                {/* Company column – center aligned when logged in */}
                <div className={`${props.user_loged_in ? 'md:text-center' : 'md:text-left'}`}>
                    <h4 className="font-semibold mb-2">Company</h4>
                    <ul className={`space-y-1 text-slate-300 ${props.user_loged_in ? 'md:inline-block' : ''}`}>
                    <li><a href="/About" className="hover:text-white">About</a></li>
                    <li><a href="/Contact" className="hover:text-white">Contact</a></li>
                    {/* <li><a href="/Career" className="hover:text-white">Career</a></li> */}
                    </ul>
                </div>

                {/* Legal column – right aligned when logged in */}
                <div className={`${props.user_loged_in ? 'md:text-right' : 'md:text-left'}`}>
                    <h4 className="font-semibold mb-2">Legal</h4>
                    <ul className={`space-y-1 text-slate-300 ${props.user_loged_in ? 'md:inline-block md:text-right' : ''}`}>
                    <li><a href="/Terms" className="hover:text-white">Terms</a></li>
                    <li><a href="/Privacy" className="hover:text-white">Privacy</a></li>
                    {/* <li><a href="/SiteTutorial" className="hover:text-white">Site Tutorial</a></li> */}
                    </ul>
                </div>
            </div>

    
            <div className="mt-8 text-xs text-slate-500">
              © {new Date().getFullYear()} CryptoMarketDarts. All Rights Reserved.
            </div>
          </div>
        </footer>
      );
}